var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:['share-btn', _vm.isRightBtn ? 'rightBtn' : '', _vm.isHonorRoll ? 'is-honor-roll' : ''],style:(_vm.buttonStyle),on:{"click":_vm.handleClick}},[_c('i',{staticClass:"shart-icon"}),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }